import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	personAvatarLabel: {
		id: 'personAvatar.label',
		defaultMessage: 'Person Avatar',
		description: 'Default person avatar icon for users',
	},
	initialsAvatarLabel: {
		id: 'initialsAvatar.label',
		defaultMessage: 'Initials Avatar',
		description: "Avatar with user's initials",
	},
});
